import PensionsInfoFlereOplysingerView from './PensionsInfoFlereOplysingerView.js';

export default PensionsInfoFlereOplysingerView;
